import * as React from 'react';
import ReactDOM from 'react-dom';
import MfaView from './MfaView';
import { MfaViewProps } from './MfaView';
import { TrackJs } from 'common/analytics/TrackJs';


export const MfaViewRoot = (rootElem: Element, props: MfaViewProps) => {
    TrackJs.activateIfEnabled('mfa');
    ReactDOM.render(<MfaView {...props} />, rootElem);
};
